import React, { Component } from 'react';
import { } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import '../../content/css/ContractReviewer.css';
import '../../content/css/ContractReviewerHOCR.css';
import { contractReviewerActions as actions } from '../../actions';
import { contractReviewerConstants } from '../../constants';
import AuthService from '../../services/auth.service';
import Viewer from '../../helpers/documentViewer';
import LoadingListener from '../../helpers/loadingListener';
import HocrProofreader from '../../helpers/HocrProofreader';

var authService = new AuthService();
const DisplayMode = {
    NORMAL: 'NORMAL',
    SHOW_ORIGINAL: 'SHOW_ORIGINAL',
    SHOW_DEVIATION: 'SHOW_DEVIATION',
    SHOW_BASE: 'SHOW_BASE'
};

class ExportHOCRView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            highlights: [],
            selectedHighlight: -1,
            filter: { type: 'predicted', importance: ['low', 'medium', 'high'] },
            lastUpdate: 0,
            textToPredict: "",
            displayMode: DisplayMode.NORMAL,
            comparisonDocumentId: ""
        };

        this.HocrReader = new HocrProofreader({
            layoutContainer: 'export-layout-container',
            editorContainer: 'export-editor-container'
        });
        this.loadingListener = new LoadingListener([contractReviewerConstants.GET_DOCUMENT_ANALYSIS_REQUEST]);
    }

    componentDidMount() {
        if (this.getCurrentDocument()) this.applyFilter(this.state.filter, this.state.filter, true);
        else this.HocrReader.init();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        if (this.props.analyzedDocuments !== prevProps.analyzedDocuments) {
            let oldDocument = this.getCurrentDocument(prevProps);
            let newDocument = this.getCurrentDocument();

            if (newDocument.highlights !== oldDocument.highlights) {
                if (this.state.filter.type === 'predicted') {
                    this.applyFilter(this.state.filter, prevState.filter, true);
                    //this.selectHighlight(0);
                }
            }
        }

        if (this.state.highlights !== prevState.highlights) {
            this.setHOCR();
        }
    }

    async setHOCR() {

        let doc = this.getCurrentDocument();
        let self = this;
        await new Promise((resolve, reject) => {
            self.HocrReader.setHocr(doc.documentHtml, doc.images);
            resolve();
        });        

        let element = document.getElementsByClassName("export-document-container")[0];

        Viewer.highlightTextSegments(this.state.highlights, element);
        this.handleHighlightDone();
        this.props.onInit();
    }

    getCurrentDocument(props = this.props) {
        let id = props.id;
        if (this.state.displayMode == DisplayMode.SHOW_BASE) id = this.state.comparisonDocumentId;
        else if (this.state.displayMode == DisplayMode.SHOW_DEVIATION) id = `${props.id}-${this.state.comparisonDocumentId}`;

        let doc = props.analyzedDocuments[id];
        doc = doc ? doc : {
            highlights: [],
            missingHighlights: [],
            segments: []
        };

        return doc;
    }

    applyFilter(filter, prevFilter, force = false) {
        if (filter.type === 'all' && (prevFilter.type !== 'all' || force)) {
            if (this.getCurrentDocument().segments.length == 0) this.props.requestDocumentSegments(this.props.id);
            else this.setState({ highlights: this.getCurrentDocument().segments });
        }
        else if (filter.type === 'predicted' && (prevFilter.type !== 'predicted' || force))
            this.setState({ highlights: this.getFilterHighlights(this.getCurrentDocument().highlights) });
        else if (filter.type === 'predicted') {
            this.setState({ highlights: this.getFilterHighlights(this.getCurrentDocument().highlights) });
        }
    }

    getFilterHighlights(highlights) {
        let result = [...highlights];
        if (!this.state.filter.importance.includes('low')) result = result.filter(x => x.risk !== 0);
        if (!this.state.filter.importance.includes('medium')) result = result.filter(x => x.risk !== 1);
        if (!this.state.filter.importance.includes('high')) result = result.filter(x => x.risk !== 2);

        return result;
    }

    handleHighlightDone = (result) => {
        this.setState({ lastUpdate: new Date().getMilliseconds() });
    }

    render() {
        // let isLoading = this.loadingListener.isLoading(this.props.isLoading);

        return (
            <React.Fragment>
                <div id="export-layout-container" className="container"></div>
                <div id="export-editor-container"></div>
            </React.Fragment>
        );
    }
}

export default connect(
    state => state.contractReviewer,
    dispatch => bindActionCreators(actions, dispatch)
)(ExportHOCRView);



// WEBPACK FOOTER //
// ./src/components/DocumentViewer/ExportHOCRView.js